export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 bg-background-50">
        <div className="absolute inset-0 bg-gradient-to-br from-primary-950/30 via-background-50 to-background-50"></div>
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary-500/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 left-10 w-[400px] h-[400px] bg-accent-500/5 rounded-full blur-3xl"></div>
      </div>

      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-background-50"></div>

      <div className="relative z-10 w-full px-4 md:px-6 pt-[72px] pb-16">
        <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full text-xs font-medium bg-primary-500/15 text-primary-400 border border-primary-500/20 mb-6">
              实时更新 · 全网吃瓜第一站
            </span>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight mb-4">
              51暗网 · 吃瓜爆料聚合平台
            </h1>

            <p className="text-lg text-accent-400 font-heading mb-6">
              不生产瓜，只做最全的吃瓜入口
            </p>

            <div className="space-y-3 text-foreground-600 text-sm leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              <p>
                51暗网是专注互联网吃瓜、黑料与爆料内容的聚合入口平台，整合多站点访问通道与APP下载方式，
                覆盖娱乐圈八卦、网红塌房、社会事件深度挖掘及全网热门话题追踪，每日人工审核更新，
                确保爆料信息的时效性与入口稳定性。
              </p>
              <p>
                目前收录超过 200+ 条爆料线索，覆盖 30+ 个垂直话题领域，
                每日更新频次保持在全网吃瓜类站点前列。
              </p>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></div>
                <span className="text-xs text-foreground-500">
                  今日更新 <strong className="text-foreground-800">37条</strong>
                </span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-fire-line text-accent-500 text-sm"></i>
                <span className="text-xs text-foreground-500">
                  在线吃瓜 <strong className="text-foreground-800">12,856人</strong>
                </span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-shield-check-line text-primary-400 text-sm"></i>
                <span className="text-xs text-foreground-500">
                  入口可用率 <strong className="text-foreground-800">99.8%</strong>
                </span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <a
                href="#cards"
                className="whitespace-nowrap w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-400 text-background-50 font-medium rounded-lg transition-all duration-200 text-sm cursor-pointer"
              >
                <i className="ri-flashlight-line mr-2"></i>
                立即吃瓜
              </a>
              <a
                href="#app"
                className="whitespace-nowrap w-full sm:w-auto px-8 py-3.5 bg-background-100 hover:bg-background-200 text-foreground-700 hover:text-foreground-950 font-medium rounded-lg border border-background-300/60 transition-all duration-200 text-sm cursor-pointer"
              >
                <i className="ri-download-line mr-2"></i>
                APP下载
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[480px] aspect-[4/3] rounded-xl overflow-hidden bg-background-100 border border-background-300/40">
              <img
                src="https://readdy.ai/api/search-image?query=Dark%20mysterious%20digital%20workspace%20with%20glowing%20crimson%20screen%20displaying%20encrypted%20data%20streams%2C%20scattered%20confidential%20documents%20on%20dark%20wooden%20desk%2C%20dramatic%20noir%20lighting%20with%20deep%20shadows%2C%20cinematic%20composition%2C%20high%20contrast%2C%20moody%20atmosphere%2C%20cyberpunk%20undertones%2C%20warm%20red%20and%20black%20color%20palette%2C%20professional%20editorial%20photography%20style&width=960&height=720&seq=hero-main-visual&orientation=landscape"
                alt="51暗网吃瓜爆料聚合入口"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50/60 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}